// extracted by mini-css-extract-plugin
export default {"cls1":"Ct8AXKfDzox4lnJIfcHb","cls2":"yvH2fiDI9Npe4ydEVxlT Ct8AXKfDzox4lnJIfcHb"};